// In-stock filter handler
document.addEventListener('DOMContentLoaded', function() {
  // Check if we have the in-stock filter
  const inStockFilters = document.querySelectorAll('input[name="filter.v.availability"]');
  
  if (inStockFilters.length > 0) {
    // Get the filter state from localStorage
    const filterState = localStorage.getItem('in_stock_filter_state');
    
    // Check if we're on a search page
    const isSearchPage = window.location.pathname.includes('/search');
    
    // If this is the first visit (no stored state) or we're on a search page with no filter active
    if ((filterState === null || (isSearchPage && !window.location.search.includes('filter.v.availability=1'))) && 
        !window.location.search.includes('filter.v.availability=1')) {
      // Check the filter by default
      inStockFilters.forEach(filter => {
        filter.checked = true;
        
        // Trigger the form submission to apply the filter
        const form = filter.closest('form[is="facet-form"]');
        if (form) {
          form.dispatchEvent(new Event('change'));
        }
      });
      
      // Store the checked state
      localStorage.setItem('in_stock_filter_state', 'checked');
    } 
    // If we have a stored state, apply it
    else if (filterState !== null) {
      const shouldBeChecked = filterState === 'checked';
      
      // Only apply the stored state if it doesn't match the current URL state
      const isActiveInURL = window.location.search.includes('filter.v.availability=1');
      
      if (shouldBeChecked !== isActiveInURL) {
        inStockFilters.forEach(filter => {
          filter.checked = shouldBeChecked;
        });
      }
    }
    
    // Add event listeners to track changes
    inStockFilters.forEach(filter => {
      filter.addEventListener('change', function() {
        localStorage.setItem('in_stock_filter_state', this.checked ? 'checked' : 'unchecked');
      });
    });
  }
}); 